module.exports = __webpack_public_path__ + "static/media/notification-info.66c9c795.svg";